export default __webpack_public_path__ + "static/media/rakhi4.d212f507.jpeg";